module.exports = __webpack_public_path__ + "images/般蓝pr长图_03.jpg?v=37a1155f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图_03.jpg
 ** module id = 180
 ** module chunks = 1 2
 **/